import { Flex, Text, Box } from '@shared/components';

interface PAnalysisSectionTitleProps {
  endAdornment: JSX.Element;
}

export default function PAnalysisSectionTitle(props: Readonly<PAnalysisSectionTitleProps>) {
  const { endAdornment } = props;

  return (
    <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
      <Text variant='h4'>ผลการวิเคราะห์ความยากรายข้อ</Text>
      <Box>{endAdornment}</Box>
    </Flex>
  );
}
